import axios from 'axios';
import Vue from 'vue';
import store from '../../store/store';

const klarna = new Vue({

  data: {
    authorizationLifetime: 60 * 60 * 1000, // ms,
    sessionLifetime: 48 * 60 * 60 * 1000,
    userDataIsOutdated: false,
    cartDataIsOutdated: false,
  },

  watch: {
    'store.cart.items': {
      handler() {
        this.cartDataIsOutdated = true;
      },
      deep: true,
    },
    'store.info': {
      handler() {
        this.userDataIsOutdated = true;
      },
      deep: true,
    },
  },

  methods: {
    // Component API

    initSession(params = { successCallback: null, failureCallback: null, finalCallback: null }) {
      if (_.isEmpty(store.cart.session)) {
        this.createSession(params);
      } else if (store.cart.session.dateAdded >= (Date.now() - this.sessionLifetime)) {
        // Session is likely to still be alive; use update to ensure order is up-to-date
        this.updateSession(params);
      } else {
        this.createSession(params);
      }
    },

    fetchSession(params = { successCallback: null, failureCallback: null, finalCallback: null }) {
      if (this.userDataIsOutdated || this.cartDataIsOutdated) {
        this.updateSession(params);
      } else {
        this.responseHandler(axios.post('/api/v1/payment/fetch-session', this.currentSession().id), params);
      }
    },

    createSession(params = { successCallback: null, failureCallback: null, finalCallback: null }) {
      const orderData = Object.assign(
        {},
        store.cart,
        { deliveryData: store.customerDeliveryData },
        { shippingProduct: store.info.shippingProduct },
      );

      this.responseHandler(axios.post('/api/v1/payment/create-session', orderData), params);
    },

    updateSession(params = { successCallback: null, failureCallback: null, finalCallback: null }) {
      const orderData = Object.assign(
        {},
        store.cart,
        { deliveryData: store.customerDeliveryData },
        { shippingProduct: store.info.shippingProduct },
      );

      this.responseHandler(axios.patch('/api/v1/payment/update-session', orderData), params);
    },

    currentSession() {
      return store.cart.session;
    },

    // Internal functions

    responseHandler(promiseObj, params) {
      promiseObj
        .then((response) => {
          store.addPaymentSession(response.data.session);

          if (!_.isEmpty(response.data.order)) {
            store.orderData = response.data.order;
          }

          if (typeof params.successCallback === 'function') {
            params.successCallback(response.data);
          }
        })
        .catch((error) => {
          store.removePaymentSession();

          if (typeof params.failureCallback === 'function') {
            params.failureCallback(error);
          }
        })
        .finally((response) => {
          if (typeof params.finalCallback === 'function') {
            params.finalCallback(response);
          }
        });
    },
  },
});

export default klarna;
